<template>
    <v-container>
        <v-layout row wrap>
            <v-flex md4 sm4 xs12>
                <v-card flat>
                    <img width="250" 
                        :src="'/api/BookingInformation/Payment/?sid='+ searchId+'&merchantCode=' +merchantCode + '&paymentCode='+paymentCode">
                </v-card>
            </v-flex>
            <v-flex md8 sm8 xs12>
                <v-layout row wrap>
                    <v-flex md12 sm12 xs12>
                        <ul>
                            <li>การชำระเงินผ่าน QR code ต้องสำเร็จเท่านั้น</li>
                            <li>สามารถออกบัตรโดยสารแบบอัตโนมัติได้ภายในวันเดียวกันกับวันที่ทำการจองเท่านั้น</li>
                            <li>ระบบจะไม่อนุญาตให้ทำการออกบัตรโดยสารแบบอัตโนมัติ หลังจากเวลา 23.45 น. ของวันเดียวกัน</li>
                            <li>หากท่านชำระเงินนอกเหนือจากที่กำหนดไว้ ทางเอเย่นต์ต้องขอตรวจสอบราคาบัตรโดยสารใหม่และจะติดต่อกลับไปแจ้งรายละเอียดอีกครั้ง</li>
                        </ul>                  
                    </v-flex>
                    <v-flex md12 sm12 xs12 mt-2>
                        <ul>
                            <li>QR payment transaction must be successfully completed</li>
                            <li>Auto Ticketing can be processed for the reservation booked and paid within same day.</li>
                            <li>Auto ticketing can be processed only before 23.45 of the booking date.</li>
                            <li>If the payment is completed after 23.45 on the same booking date or after the booking date, we will recheck the fare and notify you again.</li>
                        </ul>                  
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>        
    </v-container>

</template>

<script>
/* eslint-disable */
import BookingService from '../../services/booking.service';
import Helper from '../helper';

export default {
    props:["searchId","merchantCode","paymentCode"],
    data(){
        return {
            paymentStatus:false,
            waitingStatusCheck:false,
            stopStatusCheck:false,
        }
    },
    created(){
        this.startPaymentStatusCheck();
    },
    methods:{
        getPaymentStatus(){
            BookingService.getPaymentStatus(this.searchId).then(rslt=>{
                this.paymentStatus = rslt.data.paymentStatus;
            });
        },
        startPaymentStatusCheck(){
            setInterval(() => {
                if (this.stopStatusCheck==false && this.waitingStatusCheck==false){
                    this.waitingStatusCheck=true;
                    BookingService.getPaymentStatus(this.searchId).then(rslt=>{
                        this.waitingStatusCheck=false;
                        this.paymentStatus = rslt.data.PaymentStatus;
                        this.stopStatusCheck = this.paymentStatus!="-";
                        if (this.paymentStatus=="SUCCESS"){
                            BookingService.sendToGAT(this.searchId).then(rslt=>{
                                this.$router.push({name:"BookingInfoAndPaymentResult",params:{sid:this.searchId,pm:1}});
                                this.$router.go();
                            });  
                        }                      
                    });                    
                }
            }, 5000);
        },
    },
}
</script>

<style>

</style>